import type { RefObject } from 'react'

// find mdx elements
export const getPreviewElements = (previewRef: RefObject<HTMLDivElement | null>): HTMLElement[] => {
  if (!previewRef.current) return []

  const previewContainer = previewRef.current
  const elements: HTMLElement[] = []

  const topLevelSelectors = [
    'h1',
    'h2',
    'h3',
    'p',
    'blockquote',
    'ul',
    'ol',
    'hr',
    'img',
    'pre',
    'u',
    'div.mdx-data-container',
    'table'
  ]

  for (const selector of topLevelSelectors) {
    const found = previewContainer.querySelectorAll(selector)
    for (const el of found) {
      let isTopLevel = true
      let parent = el.parentElement

      while (parent && parent !== previewContainer) {
        if (topLevelSelectors.some(sel => parent?.matches(sel))) {
          isTopLevel = false
          break
        }
        parent = parent.parentElement
      }

      if (isTopLevel && el instanceof HTMLElement && el.offsetParent !== null) {
        elements.push(el)
      }
    }
  }
  return elements.sort((a, b) => a.offsetTop - b.offsetTop)
}
